<script setup>
import {computed, onMounted, onUnmounted, ref, watch} from "vue";
import {usePage} from "@inertiajs/inertia-vue3";
import {XIcon} from "@heroicons/vue/solid";

const emit = defineEmits(['message', 'clear']);

const message = computed(() => usePage().props.value.flash);

const show = computed(() => !!message.value);

const closeMessage = () => {
    usePage().props.value.flash = null;
    emit('clear');
    stopTimer();
}

let timer;

const startTimer = () => {
    timer = setTimeout(() => {
        closeMessage();
    }, 5000);
}

const stopTimer = () => {
    clearTimeout(timer);
}

watch(message, () => {
    if (!! message.value) {
        emit('message', message.value);
        startTimer();
    }
});
</script>

<template>
    <div class="relative z-900">
        <transition name="notify">
            <div
                v-if="show"
                class="bg-gray-800 text-white rounded-md py-2 px-3 max-w-flash absolute z-50 top-14 right-10 shadow-md flex space-x-3 items-center"
                @mouseenter="startTimer"
                @mouseleave="stopTimer"
            >
                <span>
                    {{ message }}
                </span>
                <button @click.prevent="closeMessage" class="flex items-center justify-center p-2 text-red-500 hover:text-red-300">
                    <XIcon class="w-4" />
                </button>
            </div>
        </transition>
    </div>
</template>

<style scoped>
.notify-enter-active, .notify-leave-active {
    @apply transform transition-all duration-300;
}

.notify-enter-from, .notify-leave-to {
    @apply opacity-0 -translate-y-20;
}

.notify-enter-to, .notify-leave-from {
    @apply opacity-100 translate-y-0;
}
</style>
